// extracted by mini-css-extract-plugin
export default {"container":"nO-z","title":"oO-z","link":"pO-z"};